import React from 'react';
// Retained only for this page's own legacy body/h1/li rules; the admin pages
// no longer depend on them and actively override or work around them
// elsewhere (AdminPage.css, FileDrop.css, DangerZone.css, and others).
import './Drivers.css';
import StorePage from '../Components/StorePage';

const Booking = (comps) => (
    <StorePage apps={comps.bookingApps || []} title="Booking Apps" comps={comps} />
);

export default Booking;
